import React, { useState, useContext } from 'react';
import CardItem from './componente/CardItem';
import CardPreview from './componente/CardPreview';
import DeckStats from './componente/DeckStats';
import { DefaultContext } from '../../context/context_default';
import ShareIcon from '@mui/icons-material/Share';
import CostLegend from './componente/CostLegend';

const contarCartas = (lista = []) =>
	lista.reduce((acc, card) => acc + (card.qtd || 1), 0);

const VisualizacaoDeckDetalhada = ({ deck }) => {
	const { usersList, is_descktop } = useContext(DefaultContext);
	const [previewCard, setPreviewCard] = useState(null);
	const [mousePosition, setMousePosition] = useState(null);
	const [showPreview, setShowPreview] = useState(false);

	if (!deck) return <div className='text-slate-300'>Deck inválido</div>;

	const { quebrador, arvore = [], matriz = [], nome, user_id } = deck;

	const qtdArvore = contarCartas(arvore);
	const qtdMatriz = contarCartas(matriz);

	// Buscar o nome do autor
	const autor = usersList?.find(user => user.uid === user_id);
	const nomeAutor = autor?.nome || 'Autor desconhecido';

	// Função para compartilhar o deck
	const compartilharDeck = async () => {
		try {
			const url = window.location.href;
			await navigator.clipboard.writeText(url);
			alert('URL copiada para a área de transferência!');
		} catch (err) {
			console.error('Erro ao copiar URL:', err);
			alert('Erro ao copiar URL');
		}
	};

	const handleCardHover = (card, position) => {
		setPreviewCard(card);
		setMousePosition(position);
		setShowPreview(true);
	};

	const handleCardLeave = () => {
		setShowPreview(false);
		setPreviewCard(null);
		setMousePosition(null);
	};



	return (
		<>
			<div className='min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 px-4 py-10 '>
				{/* Header do Deck */}
				<div className='bg-slate-800/50 backdrop-blur-sm border-b border-slate-700 p-6 mb-6 mt-16'>
					<div className='max-w-7xl mx-auto'>
						<div className='flex justify-between items-start mb-4'>
							<div>
								<h1 className='text-3xl font-bold text-slate-100 mb-2'>{nome || 'Deck sem nome'}</h1>
								<p className='text-slate-400 text-lg'>por <span className='text-slate-300 font-medium'>{nomeAutor}</span></p>
							</div>
							<button
								onClick={compartilharDeck}
								className='flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors duration-200'
							>
								<ShareIcon className='w-5 h-5' />
								{is_descktop ? <span>Compartilhar</span> : null}

							</button>
						</div>
						<div className='flex items-center space-x-6 text-slate-300'>
							<span className='flex items-center space-x-2'>
								<span className='w-3 h-3 bg-blue-500 rounded-full'></span>
								<span>Total: {qtdArvore + qtdMatriz} cartas</span>
							</span>
							<span className='flex items-center space-x-2'>
								<span className='w-3 h-3 bg-green-500 rounded-full'></span>
								<span>Árvore: {qtdArvore}</span>
							</span>
							<span className='flex items-center space-x-2'>
								<span className='w-3 h-3 bg-purple-500 rounded-full'></span>
								<span>Matriz: {qtdMatriz}</span>
							</span>
						</div>
					</div>
				</div>

				<div className='max-w-7xl mx-auto px-6'>
					<div className='grid grid-cols-1 xl:grid-cols-3 gap-8'>
						{/* Seção de Cartas */}
				<div className='xl:col-span-2 space-y-8 w-full min-w-0'>
							{/* QUEBRADOR */}
							<div className='bg-slate-800/30 backdrop-blur-sm rounded-xl border border-slate-700 p-6'>
								<div className='flex items-center space-x-3 mb-4'>
									{/* <div className='w-8 h-8 bg-gradient-to-r from-yellow-500 to-orange-500 rounded-lg flex items-center justify-center'>
										<span className='text-white font-bold text-sm'>⚡</span>
									</div> */}
									<h2 className='text-xl font-semibold text-slate-200'>Quebrador</h2>
								</div>
								{quebrador ? (
									<CardItem
										quebrador={true}

										item={{ id: quebrador }}
										onHover={handleCardHover}
										onLeave={handleCardLeave}
									/>
								) : (
									<div className='text-slate-500 text-center py-8 border-2 border-dashed border-slate-600 rounded-lg'>
										<div className='text-4xl mb-2'>🚫</div>
										<div>Nenhum quebrador definido</div>
									</div>
								)}
							</div>

							{/* ÁRVORE E MATRIZ */}
						<div className='grid grid-cols-1 lg:grid-cols-2 gap-8 w-full max-w-full'>
								{/* ÁRVORE */}
							<div className='bg-slate-800/30 backdrop-blur-sm rounded-xl border border-slate-700 p-6 max-h-min w-full max-w-full'>
									<div className='flex justify-between items-center space-x-3 mb-4'>
										{/* <div className='w-8 h-8 bg-gradient-to-r from-green-500 to-emerald-500 rounded-lg flex items-center justify-center'>
											<span className='text-white font-bold text-sm'>🌳</span>
										</div> */}
										<div className='flex items-center space-x-3'>
											<h2 className='text-xl font-semibold text-slate-200'>Árvore</h2>
											<span className='bg-green-500/20 text-green-400 px-2 py-1 rounded-full text-sm font-medium'>
												{qtdArvore} cartas
											</span>
										</div>

										<CostLegend />
									</div>
									<div className='overflow-y-auto overflow-x-hidden scrollbar-thin scrollbar-thumb-slate-600 scrollbar-track-transparent space-y-2'>

										{arvore
											.sort((a, b) => (parseInt(a?.card?.custo ?? '0') || 0) - (parseInt(b?.card?.custo ?? '0') || 0))
											.map((item, i) => {

												return <CardItem
													key={i}
													item={item}
													onHover={handleCardHover}
													onLeave={handleCardLeave}
												/>
											}
											)}
									</div>
								</div>

								{/* MATRIZ */}
							<div className='bg-slate-800/30 backdrop-blur-sm rounded-xl border z-0 border-slate-700 p-6 max-h-min w-full max-w-full'>
									<div className='flex items-center space-x-3 mb-4'>
										{/* <div className='w-8 h-8 bg-gradient-to-r from-purple-500 to-violet-500 rounded-lg flex items-center justify-center'>
											<span className='text-white font-bold text-sm'>🔮</span>
										</div> */}
										<h2 className='text-xl font-semibold text-slate-200'>Matriz</h2>
										<span className='bg-purple-500/20 text-purple-400 px-2 py-1 rounded-full text-sm font-medium'>
											{qtdMatriz} cartas
										</span>
									</div>
									<div className='overflow-y-auto overflow-x-hidden scrollbar-thin scrollbar-thumb-slate-600 scrollbar-track-transparent space-y-2'>
										{matriz
											.sort((a, b) => (b.qtd || 1) - (a.qtd || 1))
											.map((item, i) => (
												<CardItem
													key={i}
													item={item}
													onHover={handleCardHover}
													onLeave={handleCardLeave}
												/>
											))}
									</div>
								</div>
							</div>
						</div>

						{/* Seção de Estatísticas */}
						<div className='xl:col-span-1'>
							<div className='sticky top-20'>
								<DeckStats
									deck={deck}
									arvore={arvore}
									matriz={matriz}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Card Preview */}
			<CardPreview
				card={previewCard}
				mousePosition={mousePosition}
				visible={showPreview}
			/>
		</>
	);
};

export default VisualizacaoDeckDetalhada;
